import { denormalizeFromState } from '@/helpers/utility';
import * as schemas from '@/schemas';

const state = {
    loadingCart: false,
    currentCartId: null,
    showCartDialog: false,
};

const getters = {
    currentCart(state, getters, rootState) {
        let cart = (state.currentCartId) ? rootState.data.carts.byId[state.currentCartId] : null;
        if (cart)
            cart = denormalizeFromState(cart, schemas.cart);

        return cart;
    },
};

const actions = {
    newCart({ commit }) {
        commit('NEW_CART');
    },
    async findCart({ commit, dispatch }, { id, code }) {
        commit('CART_LOADING');
        try {
            let cart = await dispatch('data/findCart', { id, code }, { root: true });
            commit('SELECT_CART', { cart });
        } catch (e) {
            commit('CLOSE_CART');
        }
    },
    cartSaved({ commit }, { cart }) {
        commit('SELECT_CART', { cart });
        commit('CLOSE_CART_DIALOG');
    },
    closeCartDialog({ commit }) {
        commit('CLOSE_CART_DIALOG');
    },
    closeCart({ commit }) {
        commit('CLOSE_CART');
    },
};

const mutations = {
    CLEAR_ALL(state) {
        state.loadingCart = false;
        state.currentCartId = null;
        state.showCartDialog = false;
    },

    CART_LOADING(state) {
        state.loadingCart = true;
    },
    SELECT_CART(state, { cart }) {
        state.loadingCart = false;
        state.currentCartId = cart.id;
    },
    CLOSE_CART(state) {
        state.loadingCart = false;
        state.currentCartId = null;
    },

    NEW_CART(state) {
        state.showCartDialog = true;
    },
    CLOSE_CART_DIALOG(state) {
        state.showCartDialog = false;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
